export const breadCrumb_state = {};

export const breadCrumb_actions = {
  async calculateBreadCrumb(driveId, itemId) {
    if (!driveId || !itemId) {
      return [];
    }

    return await this.calculateDriveItemsHierarchy(driveId, itemId);
  }
};

export const breadCrumb_getters = {};
